(function () {
  "use strict";
  var GRID_STORAGE_KEY = "aemi_collection_grid_v1";

  var sortBtn = null;
  var sortEl = null;
  var closeSort = function () {};

  function initFilterButton() {
    var btn = document.querySelector("[data-aemi-ctb-filter]");
    btn && btn.addEventListener("click", function () {
      var summary = document.querySelector(".mobile-facets__wrapper summary");
      summary && summary.click();
    });
  }

  function initSortDrawer() {
    sortBtn = document.querySelector("[data-aemi-ctb-sort]");
    sortEl = document.querySelector("[data-aemi-sort]");
    var sort = sortEl;
    if (!sortBtn || !sort) return;
    function open() {
      sort.hidden = false;
      document.body.style.overflow = "hidden";
      // Desktop: attach the panel to its trigger (just below the Sort by button,
      // left edges aligned, clamped to the viewport) instead of the old fixed
      // top-right corner that floated over the site header. Mobile keeps the
      // bottom sheet. Positioned after unhiding so the panel width is known.
      if (window.matchMedia("(min-width: 750px)").matches) {
        var panel = sort.querySelector(".aemi-sort__panel");
        if (panel) {
          var r = sortBtn.getBoundingClientRect();
          var w = panel.getBoundingClientRect().width || 420;
          var left = Math.min(Math.max(16, Math.round(r.left)), Math.max(16, window.innerWidth - w - 16));
          panel.style.top = Math.round(r.bottom + 10) + "px";
          panel.style.left = left + "px";
          panel.style.right = "auto";
          panel.style.bottom = "auto";
        }
      }
    }
    function close() {
      sort.hidden = true;
      document.body.style.overflow = "";
    }
    closeSort = close;
    sortBtn.addEventListener("click", open);
    sort.querySelectorAll("[data-aemi-sort-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      !sort.hidden && e.key === "Escape" && close();
    });
    var form = sort.querySelector("[data-aemi-sort-form]");
    form && form.addEventListener("change", function (e) {
      if (e.target && e.target.name === "sort_by") {
        var params = new URLSearchParams(window.location.search);
        params.set("sort_by", e.target.value);
        window.location.search = params.toString();
      }
    });
  }

  function initOutsideClose() {
    // Close-on-outside-click for the sort panel and the filter drawer.
    // Registered in the CAPTURE phase on purpose: this theme (and its apps)
    // stop propagation in the bubble phase on several ancestors, which has
    // silently killed document-level handlers before. Capture always fires.
    document.addEventListener("pointerdown", function (e) {
      var t = e.target;
      // Sort panel
      if (sortEl && !sortEl.hidden) {
        var panel = sortEl.querySelector(".aemi-sort__panel");
        var insidePanel = panel && panel.contains(t);
        var onTrigger = sortBtn && sortBtn.contains(t);
        if (!insidePanel && !onTrigger) closeSort();
      }
      // Filter drawer (theme mobile-facets details)
      var det = document.querySelector(".mobile-facets__wrapper details[open]");
      if (det) {
        var inner = det.querySelector(".mobile-facets__inner");
        var filterBtn = document.querySelector("[data-aemi-ctb-filter]");
        var sum = det.querySelector("summary");
        var inside = inner && inner.contains(t);
        var onBtn = (filterBtn && filterBtn.contains(t)) || (sum && sum.contains(t));
        if (!inside && !onBtn && sum) sum.click();
      }
    }, true);
    // Escape also closes the filter drawer (sort already handles Escape)
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var det = document.querySelector(".mobile-facets__wrapper details[open]");
      if (det) {
        var sum = det.querySelector("summary");
        sum && sum.click();
      }
    });
  }

  function applyGrid(cols) {
    var grid = document.getElementById("product-grid");
    grid && (grid.classList.remove("aemi-grid-1", "aemi-grid-2"), grid.classList.add("aemi-grid-" + cols));
    document.body.classList.remove("aemi-grid-1", "aemi-grid-2");
    document.body.classList.add("aemi-grid-" + cols);
    document.querySelectorAll("[data-aemi-ctb-grid]").forEach(function (btn) {
      btn.classList.toggle("aemi-ctb__grid-btn--active", btn.getAttribute("data-aemi-ctb-grid") === String(cols));
    });
  }

  function initGridToggle() {
    var saved = null;
    try { saved = localStorage.getItem(GRID_STORAGE_KEY); } catch (e) {}
    applyGrid(saved === "1" ? 1 : 2);
    document.querySelectorAll("[data-aemi-ctb-grid]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var cols = btn.getAttribute("data-aemi-ctb-grid");
        applyGrid(cols);
        try { localStorage.setItem(GRID_STORAGE_KEY, cols) } catch (e) {}
      });
    });
  }

  function init() {
    initFilterButton();
    initSortDrawer();
    initOutsideClose();
    initGridToggle();
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
})();
